import React, { useContext, useMemo } from 'react';

import { makeStyles } from '@mui/styles';
import { Card, Grid, Paper, Typography } from '@mui/material';
import useMetric from '../../../lib/hooks/useMetric';
import { PatientTabsContext } from '../../../lib/contexts';
import { AdminProgressBar } from '../../../components/AdminProgressBar';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'inline-flex',
    overflowX: 'scroll',
    marginLeft: 25,
  },
}));

const PatientTipOfDay = () => {
  const classes = useStyles();
  const {
    state: { currentTab },
  } = useContext(PatientTabsContext);
  const { isLoading, data } = useMetric('tip_of_the_day', currentTab.id);
  return (
    <Grid
      item
      className={classes.container}
    >
      {/* {console.log(currentTab, data)} */}
      <Paper variant={'outlined'}>
        {isLoading ? (
          <AdminProgressBar />
        ) : (
          <>
            {data && (
              <>
                <Typography>{data.title}</Typography>
                <Typography>{data.metric.value}</Typography>
              </>
            )}
          </>
        )}
      </Paper>
    </Grid>
  );
};

export default PatientTipOfDay;
